var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "header" }, [
    _c(
      "div",
      {
        staticClass: "header_environment",
        class: {
          header_environment__success: !_vm.isTest,
          header_environment__danger: _vm.isTest
        }
      },
      [
        _vm.isTest
          ? _c("span", [_vm._v("Você está em ambiente de SANDBOX")])
          : _vm._e()
      ]
    ),
    _vm._v(" "),
    _vm.remoteAccessInfo.active
      ? _c(
          "article",
          {
            staticClass:
              "message is-warning message-remote-access is-marginless"
          },
          [
            _c("div", { staticClass: "message-body" }, [
              _vm._v("\n        Você está acessando a conta "),
              _c("strong", [_vm._v(_vm._s(_vm.remoteAccessInfo.user.email))]),
              _vm._v(" |\n        ID: "),
              _c("strong", [_vm._v(_vm._s(_vm.clientId))]),
              _vm._v(
                ".\n        Antes de alterar qualquer informação, verifique se está logado na conta correta.\n      "
              )
            ])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "columns is-vcentered header_menu" }, [
      _c("div", { staticClass: "column" }, [
        _c("div", { staticClass: "columns is-vcentered" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "column is-hidden-mobile" },
            [_c("sc-client-logo", { staticClass: "header__logo" })],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "column is-narrow is-hidden-mobile" }, [
        _c("div", { staticClass: "columns is-vcentered" }, [
          !_vm.envVisibility
            ? _c(
                "div",
                { staticClass: "column is-one-quarter" },
                [_c("sc-environment")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "column is-narrow" }, [_c("sc-user")], 1)
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-narrow has-text-centered" }, [
      _c("a", { attrs: { href: "/welcome/" } }, [
        _c("img", {
          staticClass: "header__logo",
          attrs: {
            src:
              "https://s3-sa-east-1.amazonaws.com/intelipost-assets/images/logos/INTELIPOST_RGB.png",
            alt: "Intelipost"
          }
        })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00217b84", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00217b84","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/sc-header/ScHeader.vue
// module id = null
// module chunks = 